export const seoRulesTargetTypeMapper = {
  SeoPageEntity: 'page',
  SportEntity: 'sport',
  RegionEntity: 'region',
  LeagueEntity: 'league',
  CasinoCategoryEntity: 'casino-category'
}

export const belgiumSportsWebsiteId = 43;
export const belgiumCasinoWebsiteId = 44;
